
// import { getLocalStore } from './localStore'
// import Store from '../store/index'
import DynamicRouter from '../router/dynamic'
import CenterRouter from '../router/center'
import RefiningRouter from '../router/refining'
import TopicRouter from '../router/topic'
import MakeCompaintsRouter from '../router/makeComplaints'
import SummoningOrderRouter from '../router/summoningOrder'
import UserRouter from '../router/user'
import TabbarRouter from '../router/tabbar'
import questionnaire from '../router/questionnaire'
import PrizeInfo from '../router/PrizeInfo'
import groups from '../router/groups'
export function formatArraryToMap (array) {
  const map = new Map()
  array.forEach(item => {
    map.set(item.key, item)
  })
  return map
}
export function filterRouter (filterRouter, filterMap) {
  return filterRouter.filter(item => {
    if (filterMap.has(item.name)) {
      return true
    }
    return false
  })
}
export function filterRoute (routerAuth) {
  // const routers = Store.getters('router/getRouter') || getLocalStore('router')
  const { exerlandRouter, tabbarRouter } = routerAuth
  const exerlandMap = formatArraryToMap(exerlandRouter)
  const tabbarMap = formatArraryToMap([
    ...tabbarRouter,
    {
      key: 'FilterFind',
      label: '发现'
    }
  ])
  const allRoute = [
    ...DynamicRouter,
    ...UserRouter,
    ...SummoningOrderRouter,
    ...MakeCompaintsRouter,
    ...TopicRouter,
    ...CenterRouter,
    ...RefiningRouter,
    ...groups,
    ...questionnaire,
    ...PrizeInfo
  ]
  const exerlandFilterRouter = filterRouter(allRoute, exerlandMap)
  const tabbarFilterRouter = filterRouter(TabbarRouter, tabbarMap)
  return {
    exerlandRouter: exerlandFilterRouter,
    tabbarRouter: tabbarFilterRouter
  }
}
